import tableLoaderDark from "@/src/assets/images/dark/loaders/table.svg";
import tableLoaderLight from "@/src/assets/images/light/loaders/table.svg";
import chartLoaderDark from "@/src/assets/images/dark/loaders/chart.svg";
import chartLoaderLight from "@/src/assets/images/light/loaders/chart.svg";

export default {
  dark: {
    table: tableLoaderDark,
    chart: chartLoaderDark,
  },
  light: {
    table: tableLoaderLight,
    chart: chartLoaderLight,
  },
};
